// extracted by mini-css-extract-plugin
export default {"hamburger":"styles_hamburger__WobWk","active":"styles_active__XgP10","line":"styles_line__npSfz"};